import { BatchId, DiscoveryChatQuestion } from './model/discovery-chat.interface';

// the backend's total reserves the last slots for the final stage - one tie-breaker and five gap questions
const FINAL_STAGE_SLOTS = 6;

/**
 * Progress (0-100) to show while questionList[pos] is on screen - the share of questions answered before it.
 * Standard questions are numbered by idx (1 .. total - 6). The final-stage questions (B99 / B100) share a single
 * idx each in the data, so they fill the last slots in the order they are shown. The ending statement is 100.
 * Returns null for inserted statements (e.g. "moving to the final stage") - the bar keeps its current value.
 */
export function getDiscoveryProgressValue(questionList: DiscoveryChatQuestion[], pos: number, total: number): number | null {
    const question = questionList[pos];
    if (!question || total <= FINAL_STAGE_SLOTS) {
        return null;
    }
    if (question.id === 'endingStatement') {
        return 100;
    }
    if (question.batchId === BatchId.System) {
        return null;
    }

    const isFinalStage = (q: DiscoveryChatQuestion) => q.batchId === BatchId.Gap || q.batchId === BatchId.Tail;
    let slot: number;
    if (isFinalStage(question)) {
        const finalStageNo = questionList.slice(0, pos + 1).filter(isFinalStage).length;
        slot = Math.min(total - FINAL_STAGE_SLOTS + finalStageNo, total);
    } else {
        slot = Math.min(Math.max(question.idx, 1), total - FINAL_STAGE_SLOTS);
    }

    return Math.floor((slot - 1) / total * 100);
}
